import React, { useEffect } from 'react';
import dataProvider from '../../lib/dataProvider';
import { getInfoValue } from '../../lib/globalData';
import { useTranslate } from 'react-admin';


import Paper from '@mui/material/Paper';


const Bookingsheet = () => {
  const tr = useTranslate();

  useEffect(() => {
    dataProvider.getOne('globLog/repBookingsheet', { id: getInfoValue('id_hostel'), sender: 'repBookingsheet' })
      .then(res  => {
        console.log(res)
      })
  }, []);
  
  return (         
    <Paper style={{scroll:'auto'}} >
      <div style={{ fontWeight: 'bold', fontSize: '2em', marginTop: '3em' }}>{tr('bw.rep.bookingsheet.title')}</div>
      <div style={{ fontSize: '1.5em', marginTop: '1em' }}>{tr('bw.rep.bookingsheet.redirect')}</div>
      <div style={{ fontSize: '1.5em', marginTop: '1em' }}>{tr('bw.rep.bookingsheet.action')}</div>
    </Paper>         
  )
}
export default Bookingsheet;
